import { SourceQuote } from '@/app/components/testing-plan/components/test-details/types';
import { DownArrow } from '@/components/icons/down-arrow';
import { PropsWithChildren } from 'react';

type SourceQuoteTagProps = PropsWithChildren<{
  sources: Array<SourceQuote>;
  showLoadMoreButton?: boolean;
  loadMore?: () => void;
}>;

export default function SourceQuoteTag({ sources, showLoadMoreButton, loadMore }: SourceQuoteTagProps) {
  if (!sources || !sources.length) return null;

  return (
    <div className="source-quote-container">
      {sources.map((item, index) => (
        <p key={index} className="source-quote-text">
          {item.description}
          {item.url && (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="source-quote-link"
            >
              Read more
            </a>
          )}
        </p>
      ))}
      {showLoadMoreButton && (
        <button
          onClick={loadMore}
          className="source-quote-load-more-button"
        >
          <span className="source-quote-load-more-text">
            Load more
          </span>
          <DownArrow />
        </button>
      )}
    </div>
  );
}
